"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanStatusCode = exports.TransactionType = exports.TransactionSettingsItem = exports.DirectionCode = exports.MappedDirectionCode = exports.TransactionTypeCode = void 0;
var TransactionTypeCode;
(function (TransactionTypeCode) {
    TransactionTypeCode["LOAN2ACC"] = "LOAN2ACC";
    TransactionTypeCode["LOAN2ACC_R"] = "LOAN2ACC_R";
    TransactionTypeCode["ACC2LOANADMFEE"] = "ACC2LOANADMFEE";
    TransactionTypeCode["ACC2LOANADMFEE_R"] = "ACC2LOANADMFEE_R";
    TransactionTypeCode["SEPA2ACC_PAY"] = "SEPA2ACC_PAY";
    TransactionTypeCode["ACC2SEPA_PAY"] = "ACC2SEPA_PAY";
    TransactionTypeCode["ACC2DEPOTAX"] = "ACC2DEPOTAX";
    TransactionTypeCode["ACC2DEPOFEE"] = "ACC2DEPOFEE";
    TransactionTypeCode["ACC2LOANCARDREPL_FEE"] = "ACC2LOANCARDREPL_FEE";
    TransactionTypeCode["ACC2LOANCARDREPL_FEE_R"] = "ACC2LOANCARDREPL_FEE_R";
    TransactionTypeCode["ACC2LOANCARDCASHWITHDRAW_FEE"] = "ACC2LOANCARDCASHWITHDRAW_FEE";
    TransactionTypeCode["ACC2LOANCARDCASHWITHDRAW_FEE_R"] = "ACC2LOANCARDCASHWITHDRAW_FEE_R";
    TransactionTypeCode["ACC2LOANCARDBALANCEINQ_FEE"] = "ACC2LOANCARDBALANCEINQ_FEE";
    TransactionTypeCode["ACC2LOANCARDBALANCEINQ_FEE_R"] = "ACC2LOANCARDBALANCEINQ_FEE_R";
    TransactionTypeCode["ACC2LOANCARDFX_FEE"] = "ACC2LOANCARDFX_FEE";
    TransactionTypeCode["ACC2LOANCARDFX_FEE_R"] = "ACC2LOANCARDFX_FEE_R";
    TransactionTypeCode["ACC2CC_PAY_EANSS"] = "ACC2CC_PAY_EANSS";
    TransactionTypeCode["ACC2CC_PAY_ISS"] = "ACC2CC_PAY_ISS";
    TransactionTypeCode["CC2ACC_PAY_EANSS"] = "CC2ACC_PAY_EANSS";
    TransactionTypeCode["CC2ACC_PAY_ISS"] = "CC2ACC_PAY_ISS";
    TransactionTypeCode["ACC2LOANCHANGE"] = "ACC2LOANCHANGE";
    TransactionTypeCode["ACC2LOANCARDMONTHLY_FEE"] = "ACC2LOANCARDMONTHLY_FEE";
    TransactionTypeCode["ACC2LOANNOTIF"] = "ACC2LOANNOTIF";
    TransactionTypeCode["ACC2LOANDEBT_COLLECTION"] = "ACC2LOANDEBT_COLLECTION";
    TransactionTypeCode["ACC2LOANDEBT_NOTIF_FEEPEN"] = "ACC2LOANDEBT_NOTIF_FEEPEN";
    TransactionTypeCode["ACC2LOANINT"] = "ACC2LOANINT";
    TransactionTypeCode["ACC2LOANINTPEN"] = "ACC2LOANINTPEN";
    TransactionTypeCode["ACC2LOANPROCINT"] = "ACC2LOANPROCINT";
    TransactionTypeCode["ACC2LOANTERMINT"] = "ACC2LOANTERMINT";
    TransactionTypeCode["ACC2LOANPRI2PEN"] = "ACC2LOANPRI2PEN";
    TransactionTypeCode["ACC2LOANOBLIGATION_INTPEN"] = "ACC2LOANOBLIGATION_INTPEN";
    TransactionTypeCode["ACC2LOANCGHANGE_FEEPEN"] = "ACC2LOANCGHANGE_FEEPEN";
    TransactionTypeCode["ACC2LOANBAILIFF_REIMBPEN"] = "ACC2LOANBAILIFF_REIMBPEN";
    TransactionTypeCode["ACC2LOANCARDMONTHLY_FEE_R"] = "ACC2LOANCARDMONTHLY_FEE_R";
    TransactionTypeCode["ACC2LOANNOTIF_R"] = "ACC2LOANNOTIF_R";
    TransactionTypeCode["ACC2LOANDEBT_COLLECTION_R"] = "ACC2LOANDEBT_COLLECTION_R";
    TransactionTypeCode["ACC2LOANDEBT_NOTIF_FEEPEN_R"] = "ACC2LOANDEBT_NOTIF_FEEPEN_R";
    TransactionTypeCode["ACC2LOANPRI2PEN_R"] = "ACC2LOANPRI2PEN_R";
    TransactionTypeCode["ACC2LOANINTPEN_R"] = "ACC2LOANINTPEN_R";
    TransactionTypeCode["ACC2LOANPROCINT_R"] = "ACC2LOANPROCINT_R";
    TransactionTypeCode["ACC2LOANTERMINT_R"] = "ACC2LOANTERMINT_R";
    TransactionTypeCode["ACC2LOANOBLIGATION_INTPEN_R"] = "ACC2LOANOBLIGATION_INTPEN_R";
    TransactionTypeCode["ACC2LOANCGHANGE_FEEPEN_R"] = "ACC2LOANCGHANGE_FEEPEN_R";
    TransactionTypeCode["ACC2LOANBAILIFF_REIMBPEN_R"] = "ACC2LOANBAILIFF_REIMBPEN_R";
    TransactionTypeCode["ACC2LOANDOMESTICRECEIPT_FEE"] = "ACC2LOANDOMESTICRECEIPT_FEE";
    TransactionTypeCode["ACC2LOANDOMESTICRECEIPT_FEE_R"] = "ACC2LOANDOMESTICRECEIPT_FEE_R";
    TransactionTypeCode["ACC2LOANDOMESTICRECEIPT_FEEPEN"] = "ACC2LOANDOMESTICRECEIPT_FEEPEN";
    TransactionTypeCode["ACC2LOANDOMESTICRECEIPT_FEEPEN_R"] = "ACC2LOANDOMESTICRECEIPT_FEEPEN_R";
    TransactionTypeCode["ACC2LOANFOREIGNRECEIPT_FEE"] = "ACC2LOANFOREIGNRECEIPT_FEE";
    TransactionTypeCode["ACC2LOANFOREIGNRECEIPT_FEE_R"] = "ACC2LOANFOREIGNRECEIPT_FEE_R";
    TransactionTypeCode["ACC2LOANFOREIGNRECEIPT_FEEPEN"] = "ACC2LOANFOREIGNRECEIPT_FEEPEN";
    TransactionTypeCode["ACC2LOANFOREIGNRECEIPT_FEEPEN_R"] = "ACC2LOANFOREIGNRECEIPT_FEEPEN_R";
    TransactionTypeCode["ACC2LOANCHARGEBACKRECEIPT_FEE"] = "ACC2LOANCHARGEBACKRECEIPT_FEE";
    TransactionTypeCode["ACC2LOANCHARGEBACKRECEIPT_FEE_R"] = "ACC2LOANCHARGEBACKRECEIPT_FEE_R";
    TransactionTypeCode["ACC2LOANCHARGEBACKRECEIPT_FEEPEN"] = "ACC2LOANCHARGEBACKRECEIPT_FEEPEN";
    TransactionTypeCode["ACC2LOANCHARGEBACKRECEIPT_FEEPEN_R"] = "ACC2LOANCHARGEBACKRECEIPT_FEEPEN_R";
    TransactionTypeCode["ACC2LOANPRIOVERDRAFT"] = "ACC2LOANPRIOVERDRAFT";
    TransactionTypeCode["ACC2LOANPRIOVERDRAFT_R"] = "ACC2LOANPRIOVERDRAFT_R";
    TransactionTypeCode["ACC2LOANPRIOVERDRAFT_PEN"] = "ACC2LOANPRIOVERDRAFT_PEN";
    TransactionTypeCode["ACC2LOANPRIOVERDRAFT_PEN_R"] = "ACC2LOANPRIOVERDRAFT_PEN_R";
    TransactionTypeCode["ACC2LOANCARDISSUE_FEE"] = "ACC2LOANCARDISSUE_FEE";
    TransactionTypeCode["ACC2LOANCARDISSUE_FEE_R"] = "ACC2LOANCARDISSUE_FEE_R";
    TransactionTypeCode["INTRA2ACC_PAY"] = "INTRA2ACC_PAY";
    TransactionTypeCode["ACC2LOANFEE"] = "ACC2LOANFEE";
    TransactionTypeCode["ACC2LOANDISBURSEMENT_FEE"] = "ACC2LOANDISBURSEMENT_FEE";
    TransactionTypeCode["ACC2REPAYMENTKREDEX_FEE"] = "ACC2REPAYMENTKREDEX_FEE";
    TransactionTypeCode["ACC2LOANCERT"] = "ACC2LOANCERT";
    TransactionTypeCode["ACC2LOANCERT_R"] = "ACC2LOANCERT_R";
    TransactionTypeCode["ACC2LOANOTHER"] = "ACC2LOANOTHER";
    TransactionTypeCode["ACC2LOANOTHER_R"] = "ACC2LOANOTHER_R";
    TransactionTypeCode["ACC2LOANBREACH"] = "ACC2LOANBREACH";
    TransactionTypeCode["ACC2LOANBREACH_R"] = "ACC2LOANBREACH_R";
    TransactionTypeCode["ACC2LOANCOURT"] = "ACC2LOANCOURT";
    TransactionTypeCode["ACC2LOANCOURT_R"] = "ACC2LOANCOURT_R";
    TransactionTypeCode["ACC2LOANPRIPEN"] = "ACC2LOANPRIPEN";
    TransactionTypeCode["ACC2LOANPRIPEN_R"] = "ACC2LOANPRIPEN_R";
    TransactionTypeCode["ACC2LOANBAILIFF_REIMB"] = "ACC2LOANBAILIFF_REIMB";
    TransactionTypeCode["ACC2LOANBAILIFF_REIMB_R"] = "ACC2LOANBAILIFF_REIMB_R";
    TransactionTypeCode["ACC2LOANNOTARYREIMB"] = "ACC2LOANNOTARYREIMB";
    TransactionTypeCode["ACC2LOANCOLLECTION_AGENCY_REIMB"] = "ACC2LOANCOLLECTION_AGENCY_REIMB";
    TransactionTypeCode["ACC2LOANCOLLECTION_AGENCY_REIMB_R"] = "ACC2LOANCOLLECTION_AGENCY_REIMB_R";
    TransactionTypeCode["ACC2LOANFULL_REPAYMENT"] = "ACC2LOANFULL_REPAYMENT";
    TransactionTypeCode["ACC2LOANFULL_REPAYMENT_R"] = "ACC2LOANFULL_REPAYMENT_R";
    TransactionTypeCode["ACC2LOANCARDMONTHLY_FEEPEN"] = "ACC2LOANCARDMONTHLY_FEEPEN";
    TransactionTypeCode["ACC2LOANCARDMONTHLY_FEEPEN_R"] = "ACC2LOANCARDMONTHLY_FEEPEN_R";
})(TransactionTypeCode || (exports.TransactionTypeCode = TransactionTypeCode = {}));
var MappedDirectionCode;
(function (MappedDirectionCode) {
    MappedDirectionCode["IN"] = "IN";
    MappedDirectionCode["OUT"] = "OUT";
})(MappedDirectionCode || (exports.MappedDirectionCode = MappedDirectionCode = {}));
var DirectionCode;
(function (DirectionCode) {
    DirectionCode["Debit"] = "D";
    DirectionCode["Credit"] = "C";
})(DirectionCode || (exports.DirectionCode = DirectionCode = {}));
var TransactionSettingsItem;
(function (TransactionSettingsItem) {
    TransactionSettingsItem["FilteringPeriods"] = "TRANSACTIONS_FILTERING_PERIODS";
    TransactionSettingsItem["FilteringPeriodByDefault"] = "TRANSACTIONS_FILTERING_PERIOD_BY_DEFAULT";
    TransactionSettingsItem["FilteringMaxPeriodInYears"] = "TRANSACTIONS_FILTERING_MAX_PERIOD_IN_YEARS";
    TransactionSettingsItem["FilteringDatePickerLimits"] = "TRANSACTIONS_FILTERING_DATE_PICKER_LIMITS";
    TransactionSettingsItem["FilteringAdvancedSearchOptions"] = "TRANSACTIONS_FILTERING_ADVANCED_SEARCH_OPTIONS";
    TransactionSettingsItem["FilteringAdvancedSearchOptionByDefault"] = "TRANSACTIONS_FILTERING_ADVANCED_SEARCH_OPTION_BY_DEFAULT";
})(TransactionSettingsItem || (exports.TransactionSettingsItem = TransactionSettingsItem = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["Transaction"] = "TRANSACTION";
    TransactionType["Reservation"] = "RESERVATION";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var LoanStatusCode;
(function (LoanStatusCode) {
    LoanStatusCode["Draft"] = "DRAFT";
    LoanStatusCode["Active"] = "ACTIVE";
    LoanStatusCode["Prepared"] = "PREPARED";
    LoanStatusCode["Closed"] = "CLOSED";
    LoanStatusCode["Annulled"] = "ANNULLED";
    LoanStatusCode["Signed"] = "SIGNED";
    LoanStatusCode["Replaced"] = "REPLACED";
})(LoanStatusCode || (exports.LoanStatusCode = LoanStatusCode = {}));
